import camelCase from 'lodash/camelCase';
import { defaultCipherList } from 'constants';
const requireModule = require.context(".", false, /\.js$/); // extract js files inside the folder (true = recursively)

const modules = {};

for (var i = 0; i < requireModule.keys().length; i++) {
  var filename = requireModule.keys()[i];
  const moduleName = camelCase(filename.replace(/(\.\/|\.js)/g, ""));

  if (filename !== "./moduleLoader.js") {
    modules[moduleName] = requireModule(filename).default;
  }

}

export default modules;



// WEBPACK FOOTER //
// ./VueSrc/Common/Store/Modules/moduleLoader.js